"use strict";

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../helpers/traversal"),
    childrenByHTMLLocalName = _require.childrenByHTMLLocalName;

var HTMLCollection = require("../generated/HTMLCollection");

var DOMException = require("domexception");

var HTMLTableSectionElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLTableSectionElementImpl, _HTMLElementImpl);

  function HTMLTableSectionElementImpl() {
    _classCallCheck(this, HTMLTableSectionElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLTableSectionElementImpl).apply(this, arguments));
  }

  _createClass(HTMLTableSectionElementImpl, [{
    key: "insertRow",
    value: function insertRow(index) {
      if (index < -1 || index > this.rows.length) {
        throw new DOMException("Cannot insert a row at an index that is less than -1 or greater than the number of " + "existing rows", "IndexSizeError");
      }

      var tr = this._ownerDocument.createElement("tr");

      if (index === -1 || index === this.rows.length) {
        this.appendChild(tr);
      } else {
        var beforeTR = this.rows.item(index);
        this.insertBefore(tr, beforeTR);
      }

      return tr;
    }
  }, {
    key: "deleteRow",
    value: function deleteRow(index) {
      if (index < -1 || index >= this.rows.length) {
        throw new DOMException("Cannot delete a row at index ".concat(index, ", where no row exists"), "IndexSizeError");
      }

      if (index === -1) {
        if (this.rows.length > 0) {
          var tr = this.rows.item(this.rows.length - 1);
          this.removeChild(tr);
        }
      } else {
        var _tr = this.rows.item(index);

        this.removeChild(_tr);
      }
    }
  }, {
    key: "rows",
    get: function get() {
      var _this = this;

      if (!this._rows) {
        this._rows = HTMLCollection.createImpl([], {
          element: this,
          query: function query() {
            return childrenByHTMLLocalName(_this, "tr");
          }
        });
      }

      return this._rows;
    }
  }]);

  return HTMLTableSectionElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLTableSectionElementImpl
};